/* eslint-disable strict */

'use strict';

(function ShopifyOneTrust() {
  // C0002 is the internal category used by OneTrust to signal consent has been given for performance cookies
  var performanceCookieCategory = ',C0002,';
  var maxTries = 5;
  var retryInterval = 1000;
  var attempts = 0;
  var interval;

  function waitForOneTrust() {
    var hasOneTrustLoaded = SetupOneTrust();

    if (!hasOneTrustLoaded) {
      attempts = 0;
      interval = setInterval(function () {
        if (SetupOneTrust() || attempts >= maxTries) {
          clearInterval(interval);
        }
        attempts++;
      }, retryInterval);
    }
  }

  function SetupOneTrust() {
    if (typeof window.OnetrustActiveGroups === 'string' && typeof window.Shopify.customerPrivacy !== 'undefined') {
      // Trigger now
      optanonWrapper();

      // Wrap and trigger after cookie opt-in from OneTrust form
      // OptanonWrapper is set and called by the OneTrust script, injected by GTM
      window.OptanonWrapper = optanonWrapper;

      return true;
    }

    return false;
  }

  function optanonWrapper() {
    var isConsentGiven = false;
    if (window.OnetrustActiveGroups.indexOf(performanceCookieCategory) !== -1) {
      isConsentGiven = true;
    }

    window.Shopify.customerPrivacy.setTrackingConsent(isConsentGiven, () => {
      // no callback needed
    });
  }

  waitForOneTrust();
})();
